import { InteractionTransferType } from "./interaction-transfer-type.enum";
import { RandomGenerator } from "../../test-utils";
var InteractionTransferInfoBuilder = /** @class */ (function () {
    function InteractionTransferInfoBuilder() {
        this.transferInfo = {
            transferDate: Date.now(),
            transferredFromGroupId: RandomGenerator.id(),
            transferredToGroupId: RandomGenerator.id(),
            transferredFromSkillIds: [],
            transferredToSkillIds: [],
            transferredToAgentId: RandomGenerator.id(),
            transferredFromAgentId: RandomGenerator.id(),
            transferredByAgentId: RandomGenerator.id(),
            transferredToInteractionId: RandomGenerator.id(),
            transferType: InteractionTransferType.ONLINE,
        };
    }
    InteractionTransferInfoBuilder.prototype.withTransferDate = function (transferDate) {
        this.transferInfo.transferDate = transferDate;
        return this;
    };
    InteractionTransferInfoBuilder.prototype.withTransferredFromGroupId = function (groupId) {
        this.transferInfo.transferredFromGroupId = groupId;
        return this;
    };
    InteractionTransferInfoBuilder.prototype.withTransferredToGroupId = function (groupId) {
        this.transferInfo.transferredToGroupId = groupId;
        return this;
    };
    InteractionTransferInfoBuilder.prototype.withTransferredFromSkillIds = function (skillIds) {
        this.transferInfo.transferredFromSkillIds = skillIds;
        return this;
    };
    InteractionTransferInfoBuilder.prototype.withTransferredToSkillIds = function (skillIds) {
        this.transferInfo.transferredToSkillIds = skillIds;
        return this;
    };
    InteractionTransferInfoBuilder.prototype.withTransferredToAgentId = function (agentId) {
        this.transferInfo.transferredToAgentId = agentId;
        return this;
    };
    InteractionTransferInfoBuilder.prototype.withTransferredFromAgentId = function (agentId) {
        this.transferInfo.transferredFromAgentId = agentId;
        return this;
    };
    InteractionTransferInfoBuilder.prototype.withTransferredByAgentId = function (agentId) {
        this.transferInfo.transferredByAgentId = agentId;
        return this;
    };
    InteractionTransferInfoBuilder.prototype.withTransferredToInteractionId = function (interactionId) {
        this.transferInfo.transferredToInteractionId = interactionId;
        return this;
    };
    InteractionTransferInfoBuilder.prototype.withTransferType = function (transferType) {
        this.transferInfo.transferType = transferType;
        return this;
    };
    InteractionTransferInfoBuilder.prototype.build = function () {
        return this.transferInfo;
    };
    return InteractionTransferInfoBuilder;
}());
export { InteractionTransferInfoBuilder };
//# sourceMappingURL=interaction-transfer-info.builder.js.map